import { get } from 'lodash';

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
    ClickAwayListener,
    Grow,
    MenuItem,
    Paper,
    Popper,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import Divider from '@material-ui/core/Divider';
import useStyle from './SelectStyle';
import Tooltip from '../../material-ui-kit/Tooltip/Tooltip';

// Modified by AI on 05/26/2026. Edit #1.
const OptionsPopper = ({
    className = '',
    testId = 'options',
    isLeftAligned = false,
    options = [],
    placement: dropdownPlacement = 'bottom-start',
    anchorEl,
    isOpen = false,
    onOpenStateChange = () => {},
    onOptionSelect = () => {},
    isLoading = false,
}) => {
    const { t } = useTranslation();

    const classes = useStyle({ isOpen, isLeftAligned });

    return (
        <Popper
            className={className}
            open={isOpen}
            anchorEl={anchorEl}
            role={undefined}
            transition
            disablePortal
            placement={dropdownPlacement}
        >
            {({ TransitionProps, placement }) => (
                <Grow
                    {...TransitionProps}
                    style={{
                        transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                >
                    <ClickAwayListener onClickAway={() => onOpenStateChange(false)}>
                        <Paper
                            className={classes.paper}
                            square
                            data-test-id={testId}
                        >
                            {(options || [])
                                .filter((selectItem) => !get(selectItem, 'isHidden', false))
                                .map((selectItem, index) => {
                                    if (selectItem.dividerLine) {
                                        return (
                                            <Divider variant="fullWidth"
                                                orientation="horizontal" key={index}
                                                style={{ margin: '5px 0' }}
                                            />
                                        );
                                    }

                                    const item = (
                                        <MenuItem
                                            key={index}
                                            className={`${classes.option} ${selectItem.disabled ? classes.optionDisabled : ''}`}
                                            focus='true'
                                            data-test-id={selectItem.testId || `${testId}-${selectItem.label}`}
                                            onClick={(e) => {
                                                if (selectItem.disabled) {
                                                    return;
                                                }

                                                e.preventDefault();
                                                e.stopPropagation();

                                                if (selectItem.onClick) {
                                                    selectItem.onClick(selectItem.value);
                                                } else {
                                                    onOptionSelect(selectItem.value);
                                                }

                                                onOpenStateChange(false);
                                            }}>
                                            {t(selectItem.label)}
                                        </MenuItem>
                                    );

                                    if (selectItem.tooltip) {
                                        return (
                                            <Tooltip title={selectItem.tooltip} key={index}>
                                                <div>
                                                    {item}
                                                </div>
                                            </Tooltip>
                                        );
                                    }

                                    return item;
                                })
                            }
                        </Paper>
                    </ClickAwayListener>
                </Grow>
            )}
        </Popper>
    );
};

OptionsPopper.propTypes = {
    className: PropTypes.string,
    testId: PropTypes.string,
    isLeftAligned: PropTypes.bool,
    options: PropTypes.array,
    placement: PropTypes.oneOf([
        'bottom-end',
        'bottom-start',
        'bottom',
        'left-end',
        'left-start',
        'left',
        'right-end',
        'right-start',
        'right',
        'top-end',
        'top-start',
        'top',
    ]),
    anchorEl: PropTypes.any,
    isOpen: PropTypes.bool,
    onOpenStateChange: PropTypes.func,
    onOptionSelect: PropTypes.func,
    isLoading: PropTypes.bool,
};

export default memo(OptionsPopper);
